import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MdsSpinnerComponent } from '@medpacesoftwaredevelopment/designsystem';

@Component({
    selector: 'medpace-loading',
    standalone: true,
    imports: [MdsSpinnerComponent],
    templateUrl: './loading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
    constructor() {}
}
